module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n  }\r\n  .error-msg{\r\n    color:red;\r\n    font-size:12px;\r\n    margin-top:-2px;\r\n    display: block;\r\n  }\r\n\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/dependents/dependents.component.css
// module id = ./src/app/sainik-registration/dependents/dependents.component.css
// module chunks = main